import ArrowRightIcon from '@heroicons/react/24/outline/ArrowRightIcon';
import { Alert, Button, Text } from 'atp-react-ui';
import { useNavigate } from 'react-router';

import { ContactSupportButton } from './ContactSupportButton';

export function UserNotFoundInstructorError({ onReset }: { onReset: () => void }) {
  const nav = useNavigate();

  const navigateToInstructorPortal = () => {
    nav('/instructor');
  };

  return (
    <>
      <Text as="h3" className="self-center">
        User not found
      </Text>
      <Alert type="info" className="-mx-2 md:-mx-4">
        If you are trying to Sign In to the Instructor Portal, use the button below to access it.
      </Alert>
      <Button as="contained" theme="primary" iconRight={ArrowRightIcon} onClick={navigateToInstructorPortal}>
        Instructor Portal
      </Button>
      <div className="flex flex-col gap-2">
        <ContactSupportButton />
        <Button as="link" size="sm" className="self-center" onClick={onReset}>
          Sign in
        </Button>
      </div>
    </>
  );
}
